import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import { animateToScreen } from '../../redux/ui/actions';
import { setTicketPassengers } from '../../redux/cardReader/actions';
import { TICKET_TYPE_EXTRA_TICKET } from '../../constants';
import CurrentZoneSelector from '../../containers/CurrentZoneSelector';
import CurrentZoneSelectorWrapper from '../../molecules/CurrentZoneSelectorWrapper';
import RegionDescription from '../../molecules/RegionDescription';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import TextColumnContent from '../../molecules/TextColumnContent';
import { H2, Text } from '../../components/Typography';

class ExtraTicketRegionTexts extends PureComponent {
  componentDidMount() {
    this.props.resetPassengers();
  }

  render() {
    const { goBackToHome, t } = this.props;
    return (
      <>
        <BackButtonContainer
          fadeIn
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.extraTicket')}
          onClick={goBackToHome}
        />
        <TextColumnContent paddingTop={-80}>
          <H2>
            <Trans i18nKey="ExtraTicketRegion.title" />
          </H2>
          <UpperContainer>
            <RegionDescription
              description={
                <Text>
                  <Trans i18nKey="ExtraTicketRegion.disclaimer" />
                </Text>
              }
            />
            <CurrentZoneSelectorWrapper>
              <CurrentZoneSelector additionalInfoI18nKey="ExtraTicketRegion.disclaimer" />
            </CurrentZoneSelectorWrapper>
          </UpperContainer>
          <CollapsibleContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <RegionDescription
                description={
                  <Text>
                    <Trans i18nKey="ExtraTicketRegion.disclaimer" />
                  </Text>
                }
              />
              <CurrentZoneSelectorWrapper>
                <CurrentZoneSelector additionalInfoI18nKey="ExtraTicketRegion.disclaimer" />
              </CurrentZoneSelectorWrapper>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

ExtraTicketRegionTexts.propTypes = {
  goBackToHome: PropTypes.func.isRequired,
  resetPassengers: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  resetPassengers: () => dispatch(setTicketPassengers(TICKET_TYPE_EXTRA_TICKET, 1)), // eslint-disable-line
  goBackToHome: () => dispatch(animateToScreen('Home')),
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(ExtraTicketRegionTexts);
